export default __webpack_public_path__ + "static/media/prev-antenna-2.faa4f5ce.png";